import classNames from 'classnames';
import { ButtonHTMLAttributes, FC, PropsWithChildren } from 'react';

type ActionButtonProps = {
  size?: 'base' | 'small';
  isActive?: boolean;
} & ButtonHTMLAttributes<HTMLButtonElement>;

const SIZE_CLASSNAMES: Record<ActionButtonProps['size'], string> = {
  base: 'p-3',
  small: 'p-2',
};

const ActionButton: FC<PropsWithChildren<ActionButtonProps>> = ({
  size = 'base',
  isActive = false,
  className,
  children,
  ...buttonProps
}) => {
  return (
    <button
      type="button"
      className={classNames(
        'flex items-center justify-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-secondary-50 disabled:opacity-50',
        isActive
          ? 'bg-secondary-25 hover:bg-secondary-25'
          : 'bg-neutral-50 hover:bg-neutral-100/75',
        SIZE_CLASSNAMES[size],
        className,
      )}
      {...buttonProps}
    >
      {children}
    </button>
  );
};

export default ActionButton;
